import YTPlayer from 'yt-player';

export default {
  init() {

  },
  finalize() {
    if ($('.header-promo-vid').length > 0) {
      // Video banner.
      const player = new YTPlayer('#header-promo-vid', {
        autoplay: true,
        controls: false,
        keyboard: false,
        annotations: false,
        fullscreen: false,
        modestBranding: true,
        related: false,
        playsInline: true,
      });

      player.load($('.header-promo-vid').data('yt-id'));
      player.mute();

      player.on('cued', () => {
        player.play();
      });

      player.on('playing', () => {
        $('.header-promo-vid-splash').addClass('hide');
      });

      player.on('ended', () => {
        // repeat.
        player.play();
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js